import { httpClient } from '@/api/http-client';
import type { EmployeeDashboardSummary } from '@/entities/employee-dashboard';

class EmployeeDashboardService {
  httpClient = httpClient;
  endpoint = '/employee-dashboard';

  async getSummary() {
    const res = await this.httpClient.get<EmployeeDashboardSummary>(`${this.endpoint}/summary`, {});
    return res.data;
  }
}

export const employeeDashboardService = new EmployeeDashboardService();
